import type { Match, RenderErrorArgs, RenderReadyArgs } from 'found';
import { useRef } from 'react';

// found 1.3 sets its router context to the render args of *every* resolver
// iteration, pending ones included, where found 0.3 only ever published the
// match it had already resolved. Consumers that read the match outside an event
// handler therefore see destinations the user may never reach. This is found's
// own resolved predicate (`createBaseRouter.js:160`) applied to the value: the
// `elements` key is always present and merely undefined while pending, so an
// `in` check would filter nothing.
const isResolved = (match: Match | undefined) => {
	const renderArgs = match as Partial<RenderReadyArgs & RenderErrorArgs> | undefined;
	return Boolean(renderArgs?.elements || renderArgs?.error);
};

export const useResolvedMatch = (match: Match) => {
	const lastResolved = useRef<Match | undefined>(undefined);
	if (isResolved(match)) {
		lastResolved.current = match;
	}
	return lastResolved.current ?? match;
};
